module.exports = __webpack_public_path__ + "static/media/cwiczenia-ortograficzne-online-ws4.a023dce8.png";